window.JuicePressStoreLocator = window.JuicePressStoreLocator || '';
window.JuicePressStoreLocator = (function(JPSTORELOCATOR){

    var cache = {};
    // share location error msg element
    // const _lsErrorMsgElem = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_location_share_error_msg_id);   
    let _searchInput = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_search_input_id);
    if (window.location.href.includes('/location')) {
        _searchInput = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_location_search_input_id);
    }
    const _locationShareElem = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_location_share_id);
    const _storeSearchBtn = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_store_search_id);
    const _lsErrorMsgElem = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_error_text_id);
    const options = {
        componentRestrictions: { country: "us" },
        fields: ["formatted_address", "geometry", "name", "address_components"]
    };
    const autocomplete = new google.maps.places.Autocomplete(_searchInput, options);
    autocomplete.addListener("place_changed", (data) => {
        const place = autocomplete.getPlace();
        window.JPSTORELOCATOR.current_selection.autocompletePlace = place;
        if(place?.formatted_address !== ""){
            _searchInput.value = place?.formatted_address;   
        }
    });

    const selectFirstOptionOnEnter = (input) => {
        if (!input) {
          return null;
        }
         // store the original event binding function
        let _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
        
        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
                
            if(type == 'keydown') {
                let orig_listener = listener;
                
                listener = function(event) {
                    
                    let suggestion_selected = $(".pac-item-selected").length > 0;
                    if (event.which === 13 && !suggestion_selected) {

                        let simulated_downarrow = $.Event("keydown", {
                            keyCode: 40,
                            which: 40
                        });

                        orig_listener.apply(input, [simulated_downarrow]);
                        setTimeout(() => {
                            JPSTORELOCATOR.methods.triggerEvent(_storeSearchBtn, 'click'); 
                        }, 300);
                    }

                    orig_listener.apply(input, [event]);
                };
            }
            _addEventListener.apply(input, [type, listener]);
        }

        if (input.addEventListener)
            input.addEventListener = addEventListenerWrapper;
        else if (input.attachEvent)
            input.attachEvent = addEventListenerWrapper;
    };
    let setKeyDownListener = selectFirstOptionOnEnter(_searchInput);

    
    const _options = {
        enableHighAccuracy: true
    };

    const _tmpl = (str, data) => {
       // Figure out if we're getting a template, or if we need to
        // load the template - and be sure to cache the result.
        var fn = !/\W/.test(str) ?
            cache[str] = cache[str] ||
            _tmpl(document.getElementById(str).innerHTML) :
        
        // Generate a reusable function that will serve as a template
        // generator (and which will be cached).
        new Function("obj",
        "var p=[],print=function(){p.push.apply(p,arguments);};" +
        
        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +
        
        // Convert the template into pure JavaScript
        str
            .replace(/[\r\t\n]/g, " ")
            .split("<%").join("\t")
            .replace(/((^|%>)[^\t]*)'/g, "$1\r")
            .replace(/\t=(.*?)%>/g, "',$1,'")
            .split("\t").join("');")
            .split("%>").join("p.push('")
            .split("\r").join("\\'")
        + "');}return p.join('');");
    
        // Provide some basic currying to the user
        return data ? fn( data ) : fn;
    };

    const _getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(_displayLocation, _showError, _options);
        }
        else {
            _lsErrorMsgElem ? (
                _lsErrorMsgElem.innerText = 'Sorry, your browser does not support this feature... Please Update your Browser to enjoy it'
            ) : null;
        }
    };
    // displayLocation
    const _displayLocation = (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const latlng = { lat, lng };
        _getGeolocation(lat, lng);
    };

    // Displays the different error messages
    const _showError = (error) => {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = 'You denied the request for your location.'
                ) : null;
                break;
            case error.POSITION_UNAVAILABLE:
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = 'Your Location information is unavailable.'
                ) : null;
                break;
            case error.TIMEOUT:
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = 'Your request timed out. Please try again'
                ) : null;
                break;
            case error.UNKNOWN_ERROR:
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = 'An unknown error occurred please try again after some time.'
                ) : null;
                break;
        }
    };

    const _getGeolocation = (lat, lng) => {
        const geocoder = new google.maps.Geocoder();
        const latlng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };
        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK") {
                if (results[0]) {
                    _searchInput.value = results[0].formatted_address;
                    window.JPSTORELOCATOR.source = {};
                    Object.assign(window.JPSTORELOCATOR.source,{
                        lat:results[0].geometry.location.lat,
                        lng:results[0].geometry.location.lng
                    });
                } else {
                    _lsErrorMsgElem ? (
                        _lsErrorMsgElem.innerText = 'No results found'
                    ) : null;
                }
            } else {
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = "Geocoder failed due to: " + status
                ) : null;
            }
        });
    };

    const _distanceCalculate = (lat1, lon1, lat2, lon2, unit) => {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit=="K") { dist = dist * 1.60934 }
            if (unit=="N") { dist = dist * 0.868976 }
            return dist;
        }
    };

    const clearError = () => {
        _lsErrorMsgElem ? (
            _lsErrorMsgElem.innerText = ""
        ) : null;
    };

    // setup google auto complete input
    const initPlacesAutocomplete = () => {
        
        if(!_searchInput){
            return;
        }
        if(JPSTORELOCATOR.google_api_key === ''){
            console.log('No google api key found');
            return;
        }
        if(JPSTORELOCATOR.selectors.jp_store_locator_search_input_id === ''){
            _lsErrorMsgElem ? (
                _lsErrorMsgElem.innerText = "search input not found"
            ) : null;
            return;
        }

        const _searchSubmitBtn = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_store_search_id);
        const _searchInputPlaceHolderText = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_search_input_text_id);

        autocomplete.addListener("place_changed", () => {
            clearError();
            _searchSubmitBtn ? (_searchSubmitBtn.disabled = true) : null;
            _searchInputPlaceHolderText ? (_searchInputPlaceHolderText.classList.add('hide')) : null;
            const place = autocomplete.getPlace();
            
            if (!place.geometry || !place.geometry.location) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                _lsErrorMsgElem ? (
                    _lsErrorMsgElem.innerText = "No details available for input: '" + place.name + "'"
                ) : null;
                return;
            }

            
            _searchSubmitBtn ? (_searchSubmitBtn.disabled = false) : null;
            let postalCode = null;
            if(place.address_components){
                let postalCodes = '';
                postalCodes = place.address_components.filter((address) => {
                    return (address.types.indexOf("postal_code") > -1 || address.types.indexOf("zip") > -1);
                });
                if(postalCodes.length > 0){
                    postalCode = postalCodes[0].long_name;
                }
            }
            
            window.JPSTORELOCATOR.source = {};
            sessionStorage.removeItem('location_zip');
            Object.assign(window.JPSTORELOCATOR.source,{
                lat:place.geometry.location.lat(),
                lng:place.geometry.location.lng(),
                zip:postalCode
            });

            if(postalCode){
                sessionStorage.getItem('location_zip',postalCode);
            }


            // console.log(place.geometry.location.lat());
            // console.log(place.geometry.location.lng());
            // // If the place has a geometry, then present it on a map.
            // if (place.geometry.viewport) {
            //     map.fitBounds(place.geometry.viewport);
            // } else {
            //     map.setCenter(place.geometry.location);
            //     map.setZoom(17);
            // }
            // marker.setPosition(place.geometry.location);
            // marker.setVisible(true);
            // infowindowContent.children["place-name"].textContent = place.name;
            // infowindowContent.children["place-address"].textContent =
            //     place.formatted_address;
            // infowindow.open(map, marker);
        });
        
    };

    // setup location share event
    const initLocationShare = () => {
        _getLocation();
    };

    const _clearLocationList = () => {
        let locationContainers = document.getElementsByClassName(window.JPSTORELOCATOR.selectors.jp_store_locator_wrapper_class);
        if(locationContainers){
            locationContainers = Array.prototype.slice.call(locationContainers);
            if(locationContainers.length > 0){
                locationContainers.forEach(element => {
                    element.innerHTML = '';
                    element.classList.add('hide');
                });
            }
        }
        //window.JPSTORELOCATOR.source = {};
    };
    
    if(_locationShareElem){
        _locationShareElem.addEventListener('click',() => {
            
            initLocationShare();
        });
    }

    const isNationWideShippingEnable = () => {
        let isNationEnable = window.JPSTORELOCATOR.isNationEnable || 0;
        let delivery_type_handle = window.JPSTORELOCATOR.current_selection.delivery_type_handle;
        let searchInMaxMiles = parseFloat(window.JPSTORELOCATOR.max_miles[delivery_type_handle]) || '';
        let sourceLat = window.JPSTORELOCATOR.source.lat || '';
        let sourceLng = window.JPSTORELOCATOR.source.lng || '';
        let storeLocations = window.JPSTORELOCATOR.locations;
        let sourceZip = window.JPSTORELOCATOR.source.zip || '';
        
        let availableLocationsInArea = storeLocations.filter((location) => {
            let _locLat = location.latitude;
            let _locLng = location.longitude;
            let totalDistanceInMiles = -1;
            if(_locLat !== '' && _locLng !== ''){
                totalDistanceInMiles = _distanceCalculate(sourceLat,sourceLng,_locLat,_locLng, 'M');
                totalDistanceInMiles = Math.round(totalDistanceInMiles*100)/100;
            }
            let includeLocation = false;
            if(location['location_coordinates'] !== "" && (window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'delivery' || window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'local' || window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'market')){
                let location_coordinates = location['location_coordinates'].split(",") || [];
                let area_coordinates = [];
                if(location_coordinates.length > 0){
                    for (let index = 0; index < location_coordinates.length; index++) {
                        let location_coordinate = location_coordinates[index].split("|") || [];
                        if(location_coordinate.length > 0){
                            area_coordinates.push({
                                lat:Number(location_coordinate[1]),
                                lng:Number(location_coordinate[0])
                            });
                        }
                    }
                }
                if(area_coordinates.length > 0 && window.JPSTORELOCATOR.current_selection.autocompletePlace){
                    let polygon = new google.maps.Polygon({
                        path: area_coordinates,
                        geodesic: true
                    });
                    if (google.maps.geometry.poly.containsLocation(window.JPSTORELOCATOR.current_selection.autocompletePlace.geometry.location, polygon)){
                        includeLocation = true;
                        return true;
                    } 
                }
            }
            if(includeLocation === false){
                let _zipCodes = (location['location_codes'] !== '' ? location['location_codes'].split(',') : []);
                if(_zipCodes.length > 0){
                    _zipCodes = _zipCodes.map(Function.prototype.call,String.prototype.trim);
                }
                if(_zipCodes.length > 0){
                    return _zipCodes.indexOf(sourceZip) > -1 && (window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'delivery' ? (location.type === 'market' || location.type === 'local') : (location.type === 'market-pickup'));
                }else{
                    return totalDistanceInMiles <= searchInMaxMiles && totalDistanceInMiles > -1 && (location.type === 'local' || location.type === 'standard-pickup');
                }
            }else{
                return false;
            }
        });
        
        let deliveryTypes = [];
        availableLocationsInArea.map((area) => deliveryTypes.push(area.type));
        let uniqueDataTypes = deliveryTypes.length > 0 && deliveryTypes.reduce((a,b) => {
            if(a.indexOf(b) < 0) a.push(b);
            return a;
        }, []);
        
        isNationEnable =  uniqueDataTypes ? (window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'delivery' ? ((uniqueDataTypes.indexOf('local') > -1 && uniqueDataTypes.indexOf('market') > -1) ? 0 : 2) : ((uniqueDataTypes.indexOf('standard-pickup') > -1 && uniqueDataTypes.indexOf('market-pickup') > -1) ? 0 : 2))  : 1;
        window.JPSTORELOCATOR.isNationEnable = Number(isNationEnable);
        return Number(isNationEnable); 
    };

    const getDistrictFromAddress = async (address) => {
        try {
            let districts = [];
            const geocoder = new google.maps.Geocoder();
            await geocoder.geocode({ address }, (results, status) => {
                if (status === "OK") {
                    results[0].address_components.map((item) => {
                        if (item.types.includes("sublocality_level_1") || item.types.includes("neighborhood")) {
                            districts.push(item.long_name);
                        }
                    })
                }
            });
            return districts;
        } catch (error) {
            return [];
        }
    }

    // check for available store for entered location
    const _searchForAvailableStoreInArea = async (type) => {

        let nofoundTextElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_text_id);
        let nofoundShopElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_shop_id);
        let locationWrapperElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_wrapper_id);
        let subDeliveryHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_header_id);
        let subDeliveryInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_inner_id);
        let subPickupHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_header_id);
        let subPickupInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_inner_id);
        let notfoundPickupMessage = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_shop_message_id);

        const pickupBoxElem = document.getElementById('box1');
        const deliveryBoxElem = document.getElementById('box2');
        const pickupBoxClasses = pickupBoxElem ? Array.from(pickupBoxElem.classList) : [];
        const deliveryBoxClasses = deliveryBoxElem ? Array.from(deliveryBoxElem.classList) : [];

        let sourceLat = window.JPSTORELOCATOR.source.lat || '';
        let sourceLng = window.JPSTORELOCATOR.source.lng || '';
        let storeLocations = window.JPSTORELOCATOR.locations;
        let sourceZip = window.JPSTORELOCATOR.source.zip || '';

        
        // check for current delivery method
        if((sourceLat === '' || sourceLng === '' || storeLocations.length === 0) && _searchInput){
            nofoundTextElem && _searchInput.value !== '' ? (
                nofoundTextElem.classList.remove('hide')
            ) : null;
            nofoundShopElem && _searchInput.value !== '' ? (
                nofoundShopElem.classList.remove('hide')
            ) : null;   
            locationWrapperElem && _searchInput.value !== '' ? (
                locationWrapperElem.classList.remove('hide')
            ) : null;
            if(_searchInput.value !== ''){
                _clearLocationList();
                return false;
            }
        }

        if(!_searchInput){
            nofoundTextElem ? (
                nofoundTextElem.classList.add('hide')
            ) : null;
            nofoundShopElem ? (
                nofoundShopElem.classList.add('hide')
            ) : null;   
            // locationWrapperElem ? (
            //     locationWrapperElem.classList.add('hide')
            // ) : null;
            _clearLocationList();
        }else if(_searchInput.value.trim() === ''){
            nofoundTextElem ? (
                nofoundTextElem.classList.add('hide')
            ) : null;
            nofoundShopElem ? (
                nofoundShopElem.classList.add('hide')
            ) : null;   
            // locationWrapperElem ? (
            //     locationWrapperElem.classList.add('hide')
            // ) : null;
            _clearLocationList();
        }
        
        // current delivery type slug
        let deliveryTypeHandle = window.JPSTORELOCATOR.current_selection.delivery_type_handle || '';
        if (deliveryTypeHandle === 'market-pickup' || (deliveryTypeHandle === 'nation' && pickupBoxClasses.includes('active') && !deliveryBoxClasses.includes('active'))) {
            deliveryTypeHandle = 'standard-pickup';
        }
        if (!type) {
            if (pickupBoxClasses.includes('active') && !deliveryBoxClasses.includes('active')) {
                deliveryTypeHandle = 'standard-pickup';
                subPickupHeader ? (
                    subPickupHeader.classList.add('hide')
                ) : null;
            } else {
                deliveryTypeHandle = 'local';
                $('#box4').addClass('active');
                $('#box3').removeClass('active');
                subDeliveryInner ? (
                    subDeliveryInner.classList.remove('hide')
                ) : null;
            }
        } else if (type === 'PICKUP') {
            deliveryTypeHandle = 'standard-pickup';
            subPickupHeader ? (
                subPickupHeader.classList.add('hide')
            ) : null;
        } else if (type === 'GRAB-AND-GO DELIVERY' || type === 'DELIVERY') {
            deliveryTypeHandle = 'local';
            $('#box4').addClass('active');
            $('#box3').removeClass('active');
            subDeliveryInner ? (
                subDeliveryInner.classList.remove('hide')
            ) : null;
        } else if (type === 'SUPERMARKET DELIVERY') {
            deliveryTypeHandle = 'market';
            $('#box3').addClass('active');
            $('#box4').removeClass('active');
            subDeliveryInner ? (
                subDeliveryInner.classList.remove('hide')
            ) : null;
        }
        let searchInMaxMiles = parseFloat(window.JPSTORELOCATOR.max_miles[deliveryTypeHandle]) || '';
        let isShowBaseOnMiles = false;
        if(_searchInput.value.trim() !== ''){
            isShowBaseOnMiles = true;
        }

        const districts = await getDistrictFromAddress(_searchInput.value)
        let storeLocationsDistricts = storeLocations;
        if (deliveryTypeHandle === 'local' && _searchInput.value.trim() !== '') {
            storeLocationsDistricts = await Promise.all(storeLocations.map(async (loc) => {
                if (loc.type === 'local') {
                    const locationDistricts = await getDistrictFromAddress(loc.address);
                    loc.locationDistricts = locationDistricts;
                }
                return loc;
            }));
        }
        
        let availableLocationsInArea = storeLocationsDistricts.filter((location) => {
          if (_searchInput.value.trim() === '') {
                return location.type === deliveryTypeHandle;
            }
            let _locLat = location.latitude;
            let _locLng = location.longitude;
            let totalDistanceInMiles = -1;
            let includeLocation = false;
            if(_locLat !== '' && _locLng !== ''){
                totalDistanceInMiles = _distanceCalculate(sourceLat,sourceLng,_locLat,_locLng, 'M');
                totalDistanceInMiles = Math.round(totalDistanceInMiles*100)/100;
                location['miles'] = totalDistanceInMiles;
            }

            if(location['location_coordinates'] !== "" && (deliveryTypeHandle === 'delivery' || deliveryTypeHandle === 'local' || deliveryTypeHandle === 'market')){
                let location_coordinates = location['location_coordinates'].split(",") || [];
                let area_coordinates = [];
                if(location_coordinates.length > 0){
                    for (let index = 0; index < location_coordinates.length; index++) {
                        let location_coordinate = location_coordinates[index].split("|") || [];
                        if(location_coordinate.length > 0){
                            area_coordinates.push({
                                lat:Number(location_coordinate[1]),
                                lng:Number(location_coordinate[0])
                            });
                        }
                    }
                }
                
                if(area_coordinates.length > 0 && window.JPSTORELOCATOR.current_selection.autocompletePlace){
                    let polygon = new google.maps.Polygon({
                        path: area_coordinates,
                        geodesic: true
                    });
                    if (google.maps.geometry.poly.containsLocation(window.JPSTORELOCATOR.current_selection.autocompletePlace.geometry.location, polygon) && deliveryTypeHandle === location.type) {
                        includeLocation = true;
                        return true;
                    } 
                }
            }
            
            if(includeLocation === false){
                let _zipCodes = (location['location_codes'] !== '' ? location['location_codes'].split(',') : []);
                if(_zipCodes.length > 0){
                    _zipCodes = _zipCodes.map(Function.prototype.call,String.prototype.trim);
                }

                //if(deliveryTypeHandle === 'pickup' || deliveryTypeHandle === 'local'){
                
                if(deliveryTypeHandle === 'local'){
                    if(_zipCodes.length > 0  && sourceZip !== ''){
                        return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && _zipCodes.indexOf(sourceZip) > -1) : (location.type === deliveryTypeHandle));
                    }else{
                        return location.type === deliveryTypeHandle && location.locationDistricts && location.locationDistricts.some(item => districts.includes(item));
                        // return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && totalDistanceInMiles <= searchInMaxMiles && totalDistanceInMiles > -1) : (location.type === deliveryTypeHandle));
                    }
                }else if(deliveryTypeHandle === 'pickup'){
                    return (isShowBaseOnMiles ? ((location.type === "standard-pickup" || location.type === "market-pickup") && _zipCodes.indexOf(sourceZip) > -1) : (location.type === "standard-pickup" || location.type === "market-pickup"));
                }else{
                    if(deliveryTypeHandle === 'standard-pickup'){
                        if(_zipCodes.length > 0  && sourceZip !== ''){
                            return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && _zipCodes.indexOf(sourceZip) > -1) : (location.type === deliveryTypeHandle));
                        }else{
                            return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && totalDistanceInMiles <= searchInMaxMiles && totalDistanceInMiles > -1) : (location.type === deliveryTypeHandle));
                        }
                    } else if (deliveryTypeHandle === 'market-pickup' || deliveryTypeHandle === 'market' || deliveryTypeHandle === 'nation'){
                        if ((deliveryTypeHandle === 'market' || deliveryTypeHandle === 'nation') && !pickupBoxClasses.includes('active') && deliveryBoxClasses.includes('active')) {
                            if (_searchInput.value.toLowerCase().includes('westchester county') || _searchInput.value.toLowerCase().includes('bronx') || districts.includes('Westchester County' || districts.includes('Bronx County'))) {
                                return location.title === "Westchester & Bronx";
                            } else if (_searchInput.value.toLowerCase().includes('queens') || _searchInput.value.toLowerCase().includes('brooklyn') || districts.includes('Queens') || districts.includes('Brooklyn')) {
                                return location.title === "Brooklyn & Queens";
                            } else if (_searchInput.value.toLowerCase().includes('long island') || _searchInput.value.toLowerCase().includes('hamptons') || districts.includes('Long Island') || districts.includes('The Hamptons')) {
                                return location.title === "JP Delivery Market - Long Island and Hamptons";
                            } else if (_searchInput.value.toLowerCase().includes('boston') || districts.includes('Boston')) {
                                return location.title === "JP Delivery Market - Boston";
                            } else if (_searchInput.value.toLowerCase().includes('connecticut') || districts.includes('Connecticut')) {
                                return location.title === "JP Delivery Market - Connecticut";
                            } else if (_searchInput.value.toLowerCase().includes('new jersey') || districts.includes('New Jersey')) {
                                return location.title === "JP Delivery Market - New Jersey";
                            } else if (_searchInput.value.toLowerCase().includes('upper east side') || districts.includes('Upper East Side')) {
                                return location.title === "JP Delivery Market - Upper East Side";
                            } else if (_searchInput.value.toLowerCase().includes('manhattan') || districts.includes('Manhattan') || (districts.length === 0 && _searchInput.value.toLowerCase().includes('new york'))) {
                                return location.title === "Manhattan";
                            }
                        }
                            // return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && _zipCodes.indexOf(sourceZip) > -1) : (location.type === deliveryTypeHandle));    
                        return (isShowBaseOnMiles ? (location.type === deliveryTypeHandle && ((totalDistanceInMiles <= searchInMaxMiles && totalDistanceInMiles > -1) || (_zipCodes.indexOf(sourceZip) > -1))) : (location.type === deliveryTypeHandle));
                    } 
                }   
            }else{
                return false;
            }
        });

        if(availableLocationsInArea.length === 0){
            nofoundTextElem ? (
                nofoundTextElem.classList.remove('hide')
            ) : null;
            nofoundShopElem ? (
                nofoundShopElem.classList.remove('hide')
            ) : null;   
            locationWrapperElem ? (
                locationWrapperElem.classList.remove('hide')
            ) : null;
            if((deliveryTypeHandle === 'market' || deliveryTypeHandle === 'local' || deliveryTypeHandle === 'nation') && (deliveryTypeHandle !== 'standard-pickup' && deliveryTypeHandle !== 'market-pickup')){
                subDeliveryHeader ? (
                    subDeliveryHeader.classList.add('hide')
                ) : null;
                // subDeliveryInner ? (
                //     subDeliveryInner.classList.add('hide')
                // ) : null;
            }
            if((deliveryTypeHandle === 'market-pickup' || deliveryTypeHandle === 'standard-pickup' || deliveryTypeHandle === 'nation') && (deliveryTypeHandle !== 'market' && deliveryTypeHandle !== 'local')){
                subPickupHeader ? (
                    subPickupHeader.classList.add('hide')
                ) : null;
                subPickupInner ? (
                    subPickupInner.classList.add('hide')
                ) : null;
            }
            if (deliveryTypeHandle === 'standard-pickup' || deliveryTypeHandle === 'nation') {
                if (pickupBoxClasses.includes('active') && !deliveryBoxClasses.includes('active')) {
                    notfoundPickupMessage ? (notfoundPickupMessage.classList.remove('hide')) : null;
                    nofoundTextElem ? (
                        nofoundTextElem.classList.add('hide')
                    ) : null;
                    nofoundShopElem ? (
                        nofoundShopElem.classList.add('hide')
                    ) : null;
                } else {
                    notfoundPickupMessage ? (notfoundPickupMessage.classList.add('hide')) : null;
                    nofoundTextElem ? (
                        nofoundTextElem.classList.remove('hide')
                    ) : null;
                    nofoundShopElem ? (
                        nofoundShopElem.classList.remove('hide')
                    ) : null;  
                }
            }
            _clearLocationList();
            return false;
        }
        if((deliveryTypeHandle === 'market' || deliveryTypeHandle === 'local' || deliveryTypeHandle === 'nation') && (deliveryTypeHandle !== 'standard-pickup' && deliveryTypeHandle !== 'market-pickup')){
            // subDeliveryHeader ? (
            //     subDeliveryHeader.classList.remove('hide')
            // ) : null;
            subDeliveryInner ? (
                subDeliveryInner.classList.remove('hide')
            ) : null;
        }else{
            subDeliveryHeader ? (
                subDeliveryHeader.classList.add('hide')
            ) : null;
            subDeliveryInner ? (
                subDeliveryInner.classList.add('hide')
            ) : null;
        }

        if((deliveryTypeHandle === 'market-pickup' || deliveryTypeHandle === 'standard-pickup' || deliveryTypeHandle === 'nation') && (deliveryTypeHandle !== 'market' && deliveryTypeHandle !== 'local')){
            // subPickupHeader ? (
            //     subPickupHeader.classList.remove('hide')
            // ) : null;
            subPickupInner ? (
                subPickupInner.classList.remove('hide')
            ) : null;
        }else{
            subPickupHeader ? (
                subPickupHeader.classList.add('hide')
            ) : null;
            subPickupInner ? (
                subPickupInner.classList.add('hide')
            ) : null;
        }

        if ((deliveryTypeHandle === 'nation' || deliveryTypeHandle === 'market') && !pickupBoxClasses.includes('active') && deliveryBoxClasses.includes('active')) {
            subPickupHeader ? (
                subPickupHeader.classList.add('hide')
            ) : null;
            subPickupInner ? (
                subPickupInner.classList.add('hide')
            ) : null;
        }

        if(window.JPSTORELOCATOR.isNationEnable === 2 || window.JPSTORELOCATOR.isNationEnable === 1){
            subDeliveryHeader ? (
                subDeliveryHeader.classList.add('hide')
            ) : null;
        }

        

        if(availableLocationsInArea.length > 0){
            notfoundPickupMessage ? (notfoundPickupMessage.classList.add('hide')) : null;
            // sort by near to far based on miles
            if(deliveryTypeHandle === 'standard-pickup' || deliveryTypeHandle === 'market-pickup' || deliveryTypeHandle === 'local' || deliveryTypeHandle === 'market'){
                if(isShowBaseOnMiles){
                    availableLocationsInArea.sort((a,b) => (a.miles > b.miles) ? 1 : ((b.miles > a.miles) ? -1 : 0));
                }else{
                    availableLocationsInArea.sort((a,b) => (a.sort_order > b.sort_order) ? 1 : ((b.sort_order > a.sort_order) ? -1 : 0));
                }
            }else{
                availableLocationsInArea.sort((a,b) => (a.sort_order > b.sort_order) ? 1 : ((b.sort_order > a.sort_order) ? -1 : 0));
            }
            // if (availableLocationsInArea[0].type === 'market') {
            //     $('#box3').addClass('active');
            // }
            
            let compiledLocations = [];
            availableLocationsInArea.forEach(element => {
                let location = _tmpl(window.JPSTORELOCATOR.selectors.jp_store_locator_location_template_id, element);
                location ? compiledLocations.push(location) : null;
            });
            if(compiledLocations.length > 0){
                locationWrapperElem ? (
                    locationWrapperElem.classList.remove('hide')
                ) : null;
                let locationContainers = document.getElementsByClassName(window.JPSTORELOCATOR.selectors.jp_store_locator_wrapper_class);
                if(locationContainers){
                    locationContainers = Array.prototype.slice.call(locationContainers);
                    if(locationContainers.length > 0){
                        locationContainers.forEach(element => {
                            element.innerHTML = compiledLocations.join("");
                            element.classList.remove('hide');
                        });
                    }
                }
            }
        }
        
    };

    const loadlocation = async (location, type, id) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.JuicePressStoreLocator) {
            window.JuicePressStoreLocator.clearErrorMessage();
        }
        let nofoundTextElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_text_id);
        let nofoundShopElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_shop_id);
        let locationWrapperElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_wrapper_id);
        let subDeliveryHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_header_id);
        let subDeliveryInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_inner_id);
        let subPickupHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_header_id);
        let subPickupInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_inner_id);

        window.JPSTORELOCATOR.current_selection = window.JPSTORELOCATOR.current_selection || {};
        locationWrapperElem ? (
            locationWrapperElem.classList.add('hide')
        ) : null;
        nofoundTextElem ? (
            nofoundTextElem.classList.add('hide')
        ) : null;
        nofoundShopElem ? (
            nofoundShopElem.classList.add('hide')
        ) : null;
        subDeliveryHeader ? (
            subDeliveryHeader.classList.add('hide')
        ) : null;
        subDeliveryInner ? (
            subDeliveryInner.classList.add('hide')
        ) : null;
        subPickupHeader ? (
            subPickupHeader.classList.add('hide')
        ) : null;
        subPickupInner ? (
            subPickupInner.classList.add('hide')
        ) : null;

        $('.box_header_one').removeClass('active');
        $('#box' + id).addClass('active');
        if (id === 3 || id === 4 || id === 5) {
            $('#box2').addClass('active');
            $('#box1').removeClass('active');
        } else if (id === 6 || id === 7 || id === 8) {
            $('#box1').addClass('active');
            $('#box2').removeClass('active');
        }


        window.JPSTORELOCATOR.current_selection.delivery_type = type;
        sessionStorage.setItem('delivery_type', window.JPSTORELOCATOR.current_selection.delivery_type);
        window.JPSTORELOCATOR.current_selection.delivery_type_handle = window.JPSTORELOCATOR.delivery_types[type];
        sessionStorage.setItem('delivery_type_handle', window.JPSTORELOCATOR.current_selection.delivery_type_handle);

        if (id == 1) {
            $('.pickup').css({ 'display': 'flex' });
            $('.delivery').hide();
            //$('.new_page_order_now_content_inner_box_result_store').removeClass('delivery_tab');
            $('.new_page_order_now_content_inner_box_result_store').addClass('delivery_tab');
            var desksrc = $('#box' + id).data('desk-img');
            var mobsrc = $('#box' + id).data('mob-img');
            $('.desksrc').attr("src", desksrc);
            $('.mobsrc').attr("src", mobsrc);
        }

        if (id == 2) {
            $('.pickup').hide();
            $('.delivery').css({ 'display': 'flex' });
            $('.new_page_order_now_content_inner_box_result_store').addClass('delivery_tab');
            var desksrc1 = $('#box' + id).data('desk-img');
            var mobsrc1 = $('#box' + id).data('mob-img');
            $('.desksrc').attr("src", desksrc1);
            $('.mobsrc').attr("src", mobsrc1);
        }


        // fetch current Cart
        let currentCart = await fetch('/cart.js');
        let jsonCart = await currentCart.json();
        if (jsonCart?.items?.length > 0 && window.JPSTORELOCATOR.cartClearPopup !== '') {
            Swal.fire({
                icon: "info",
                html: window.JPSTORELOCATOR.cartClearPopup,
                showCancelButton: true,
                customClass: {
                    confirmButton: 'swl-confirm-btn',
                    cancelButton: 'swl-cancel-btn'
                },
                buttonsStyling: false
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    let cartData = window.JPSTORELOCATOR.methods.clearCart ? (
                        await window.JPSTORELOCATOR.methods.clearCart()
                    ) : '';

                    window.JPSTORELOCATOR.current_selection.zapiet_location_id = '';
                    sessionStorage.removeItem('zapiet_location_id');
                    window.JPSTORELOCATOR.current_selection.zip = '';
                    sessionStorage.removeItem('location_zip');
                    window.JPSTORELOCATOR.current_selection.location_link = '';
                    sessionStorage.removeItem('location_link');
                    window.JPSTORELOCATOR.current_selection.location_title = '';
                    sessionStorage.removeItem('location_title');
                    window.JPSTORELOCATOR.current_selection.location = '';
                    sessionStorage.removeItem('location_address');
                    window.JPSTORELOCATOR.current_selection.relay_store = '';
                    sessionStorage.removeItem('relay_store');
                    window.JPSTORELOCATOR.current_selection.relay_email = '';
                    sessionStorage.removeItem('relay_email');
                    window.JPSTORELOCATOR.current_selection.order_value = 0;
                    sessionStorage.removeItem('order_value');
                    window.JPSTORELOCATOR.current_selection.order_condition = '';
                    sessionStorage.removeItem('order_condition');

                    let _searchInput = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_search_input_id);
                    let _searchSubmitBtn = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_store_search_id);
                    let _searchInputPlaceHolderText = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_search_input_text_id);
                    if ((id === 2 || id === 1) && _searchSubmitBtn) {
                        _searchInputPlaceHolderText && _searchInput.value === '' ? (_searchInputPlaceHolderText.classList.remove('hide')) : null;
                        _searchSubmitBtn.disabled = _searchInput.value === '' ? true : false;
                    } else if (id !== 2 && _searchSubmitBtn) {
                        // _searchSubmitBtn.disabled = false;
                    }


                    if (id === 1 || id === 3 || id === 4 || id === 5) {
                        // _searchInputPlaceHolderText ? (_searchInputPlaceHolderText.classList.add('hide')) : null;
                        if (window.JuicePressStoreLocator) {
                            window.JuicePressStoreLocator.searchForAvailableStoreInArea();
                        }
                    }


                }


            });

            return;
        }

        let cartData = window.JPSTORELOCATOR.methods.clearCart ? (
            await window.JPSTORELOCATOR.methods.clearCart()
        ) : '';


        window.JPSTORELOCATOR.current_selection.zapiet_location_id = '';
        sessionStorage.removeItem('zapiet_location_id');
        window.JPSTORELOCATOR.current_selection.zip = '';
        sessionStorage.removeItem('location_zip');
        window.JPSTORELOCATOR.current_selection.location_link = '';
        sessionStorage.removeItem('location_link');
        window.JPSTORELOCATOR.current_selection.location_title = '';
        sessionStorage.removeItem('location_title');
        window.JPSTORELOCATOR.current_selection.location = '';
        sessionStorage.removeItem('location_address');
        window.JPSTORELOCATOR.current_selection.relay_store = '';
        sessionStorage.removeItem('relay_store');
        window.JPSTORELOCATOR.current_selection.relay_email = '';
        sessionStorage.removeItem('relay_email');
        window.JPSTORELOCATOR.current_selection.order_value = 0;
        sessionStorage.removeItem('order_value');
        window.JPSTORELOCATOR.current_selection.order_condition = '';
        sessionStorage.removeItem('order_condition');

        let _searchInput = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_search_input_id);
        let _searchSubmitBtn = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_store_search_id);
        let _searchInputPlaceHolderText = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_search_input_text_id);
        if ((id === 2 || id === 1) && _searchSubmitBtn) {
            _searchInputPlaceHolderText && _searchInput.value === '' ? (_searchInputPlaceHolderText.classList.remove('hide')) : null;
            _searchSubmitBtn.disabled = _searchInput.value === '' ? true : false;
        } else if (id !== 2 && _searchSubmitBtn) {
            // _searchSubmitBtn.disabled = false;
        }

        //id === 1 ||
        if (id === 3 || id === 4 || id === 5 || id === 6 || id === 7 || id === 8) {
            // _searchInputPlaceHolderText ? (_searchInputPlaceHolderText.classList.add('hide')) : null;
            if (window.JuicePressStoreLocator) {
                window.JuicePressStoreLocator.searchForAvailableStoreInArea();
            }
        }

    }

    function getParentByChild(child, className) {
        if (child.className.split(' ').indexOf(className) >= 0) return child;

        try {
            //Throws TypeError if child doesn't have parent any more
            return child.parentNode && getParentByChild(child.parentNode, className);
        } catch (TypeError) {
            return false;
        }
    }

    $(document).ready(function () {

        $(document).on("click", '.toggle-time > i, .toggle-time', function (e) {
            if (window.JuicePressStoreLocator) {
                window.JuicePressStoreLocator.clearErrorMessage();
            }
            e.preventDefault();
            if (e.target.classList.contains('toggle-time')) {
                $(this).toggleClass('open');
                $(this).find('i').toggleClass('open');
                $(this).next().toggle();
            } else {
                $(this).toggleClass('open');
                $(this).parent().next().toggle();
            }
        });


        // get url params 
        const uriParams = new URLSearchParams(location.search);
        let activeTab = uriParams.get('active');
        let category = uriParams.get('category');
        const categoryList = [
            { title: 'clean-energy', param:'Clean%2520Energy' },
            { title: 'diy-smoothies-bowls', param: 'Fruit%2520Smoothies' },
            { title: 'grocery', param: 'Grocery' },
            { title: 'hydration-waters', param: 'Juices%2C%2520Shots%2520%26%2520Waters' },
            { title: 'juices', param: 'Juices%2C%2520Shots%2520%26%2520Waters' },
            { title: 'meal-plans-cleanses', param: 'Clean%2520Eating%2520Plans' },
            { title: 'prepared-foods-soups', param: 'Food' },
            { title: 'supplements-powders', param: 'Snacks' },
            { title: 'jp-swag', param: 'jp-swag' }
        ]
        let categoryParam = ''
        const categoryItem = categoryList.find((item) => item.title === category);
        if (categoryItem) {
            categoryParam = categoryItem.param;
        }

        if (activeTab !== '') {
            switch (activeTab) {
                case "pickup":
                    setTimeout(() => {
                        document.getElementById('box1') ? document.getElementById('box1').click() : undefined;
                    }, 300);
                    break;
                case "delivery":
                    setTimeout(() => {
                        document.getElementById('box2') ? document.getElementById('box2').click() : undefined;
                    }, 300);
                    break;
            }
        }


        let container = document.getElementById('myUL');
        document.addEventListener('click', function (event) {
            if (window.JuicePressStoreLocator) {
                window.JuicePressStoreLocator.clearErrorMessage();
            }

            if (container !== event.target && container.contains(event.target) && !event.target.classList.contains('jp-exclude_click')) {

                // let parentNode = (event.target.classList.contains('jp-store-locator__location') ? event.target : $(event.target).parents('.jp-store-locator__location')[0]) || '';
                let parentNode = getParentByChild(event.target, 'jp-store-locator__location');

                if (parentNode) {
                    let _id = parentNode.getAttribute('id') || '';
                    let location = window.JPSTORELOCATOR.locations.filter((location) => {
                        return location.selector === _id;
                    });
                    if (categoryParam) {
                        if (categoryParam === 'jp-swag') {
                            location[0].link = '/collections/jp-nationwide-shipping-jp-signature-line?gf_528463=304288137381&view=boost-pfs-original';
                        } else {
                            location[0].link = `${location[0].link}?category=${categoryParam}`;
                        }
                    }
                    if (location.length > 0 && location[0].link !== '') {
                        loadcoll(location[0].link, location[0].address, location[0].title, location[0].relay_store, location[0].relay_email, location[0].zapiet_location_id, location[0].order_value, location[0].order_condition);
                    }
                }
            }
        });

        // let spanInterval = setInterval(function(){ 
        //   if(container.getElementsByClassName('jp-store-locator__location')?.length > 0){    
        //     clearInterval(spanInterval);
        //     let jpStoreLocations = container.getElementsByClassName('jp-store-locator__location');
        //     if(jpStoreLocations?.length > 0){
        //       jpStoreLocations = Array.prototype.slice.call(jpStoreLocations);
        //       jpStoreLocations.forEach((jPLocation) => {
        //         jPLocation.addEventListener('click', (evt) => {
        //           let _id = evt.target.getAttribute('id') || '';
        //           let location = window.JPSTORELOCATOR.locations.filter((location) => {
        //             return location.selector === _id;
        //           });
        //           if(location.length > 0 && location[0].link !== ''){
        //             loadcoll(location[0].link,location[0].address,location[0].title,location[0].relay_store, location[0].relay_email);
        //           }
        //         });
        //       })
        //     }
        //     //remain code
        //   }
        // }, 1000);


        let nationwideShippingBtn = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_nationwide_shipping_btn_id);
        if (nationwideShippingBtn) {
            nationwideShippingBtn.addEventListener('click', () => {
                if (window.JuicePressStoreLocator) {
                    window.JuicePressStoreLocator.clearErrorMessage();
                }
                let _link = event.target.getAttribute('data-href');
                window.JPSTORELOCATOR.current_selection = window.JPSTORELOCATOR.current_selection || {};
                window.JPSTORELOCATOR.current_selection.delivery_type = 'NATIONWIDE SHIPPING'
                sessionStorage.setItem('delivery_type', window.JPSTORELOCATOR.current_selection.delivery_type);
                window.JPSTORELOCATOR.current_selection.delivery_type_handle = window.JPSTORELOCATOR.delivery_types['NATIONWIDE SHIPPING'];
                sessionStorage.setItem('delivery_type_handle', window.JPSTORELOCATOR.current_selection.delivery_type_handle);
                window.JPSTORELOCATOR.current_selection.zip = '';
                sessionStorage.removeItem('location_zip');
                window.JPSTORELOCATOR.current_selection.location_title = '';
                sessionStorage.removeItem('location_title');
                window.JPSTORELOCATOR.current_selection.location_link = '';
                sessionStorage.removeItem('location_link');
                window.JPSTORELOCATOR.current_selection.location = '';
                sessionStorage.removeItem('location_address');
                window.JPSTORELOCATOR.current_selection.relay_store = '';
                sessionStorage.removeItem('relay_store');
                window.JPSTORELOCATOR.current_selection.relay_email = '';
                sessionStorage.removeItem('relay_email');
                window.JPSTORELOCATOR.current_selection.zapiet_location_id = '';
                sessionStorage.removeItem('zapiet_location_id');
                window.JPSTORELOCATOR.current_selection.order_value = 0;
                sessionStorage.removeItem('order_value');
                window.JPSTORELOCATOR.current_selection.order_condition = '';
                sessionStorage.removeItem('order_condition');
                window.location = _link;
            });
        }

        if (document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_clear_id)) {
            let _searchInput = document.getElementById(JPSTORELOCATOR.selectors.jp_store_locator_search_input_id);
            document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_clear_id).addEventListener('click', (e) => {
                _searchInput.value = '';
                console.log(window.JPSTORELOCATOR.current_selection.delivery_type_handle);
                if (window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'standard-pickup' || window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'market-pickup') {
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box1'), 'click');
                } else {
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box2'), 'click');
                }
                document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_clear_id).style.visibility = "hidden";
            });
        }

    });

    async function loadcoll(link, location, title, relayStore = '', relayEmail = '', zapiet_location_id = '', order_value = 0, order_condition = '') {
        if (window.JuicePressStoreLocator) {
            window.JuicePressStoreLocator.clearErrorMessage();
        }

        // fetch current Cart
        let currentCart = await fetch('/cart.js');
        let jsonCart = await currentCart.json();
        if (jsonCart?.items?.length > 0 && window.JPSTORELOCATOR.cartClearPopup !== '') {
            Swal.fire({
                icon: "info",
                html: window.JPSTORELOCATOR.cartClearPopup,
                showCancelButton: true,
                customClass: {
                    confirmButton: 'swl-confirm-btn',
                    cancelButton: 'swl-cancel-btn'
                },
                buttonsStyling: false
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    let cartData = window.JPSTORELOCATOR.methods.clearCart ? (
                        await window.JPSTORELOCATOR.methods.clearCart()
                    ) : '';

                    // localStorage.setItem('title', title);
                    // localStorage.setItem('location', location);
                    window.JPSTORELOCATOR.current_selection = window.JPSTORELOCATOR.current_selection || {};

                    window.JPSTORELOCATOR.current_selection.zapiet_location_id = zapiet_location_id;
                    sessionStorage.setItem('zapiet_location_id', zapiet_location_id);
                    let parsedLocation = parseAddress.parseLocation(location);
                    if (parsedLocation || window.JPSTORELOCATOR.source) {
                        window.JPSTORELOCATOR.current_selection.zip = (window.JPSTORELOCATOR.current_selection.delivery_type_handle === "market" || window.JPSTORELOCATOR.current_selection.delivery_type_handle === "local") ? (
                            window.JPSTORELOCATOR.source.zip || parsedLocation?.zip || ''
                        ) : (parsedLocation?.zip || window.JPSTORELOCATOR.source?.zip || '');
                    }
                    sessionStorage.setItem('location_zip', window.JPSTORELOCATOR.current_selection.zip);
                    window.JPSTORELOCATOR.current_selection.location_link = link;
                    sessionStorage.setItem('location_link', link);
                    window.JPSTORELOCATOR.current_selection.location_title = title;
                    sessionStorage.setItem('location_title', window.JPSTORELOCATOR.current_selection.location_title);
                    window.JPSTORELOCATOR.current_selection.location = location;
                    sessionStorage.setItem('location_address', window.JPSTORELOCATOR.current_selection.location);
                    window.JPSTORELOCATOR.current_selection.relay_store = relayStore;
                    sessionStorage.setItem('relay_store', window.JPSTORELOCATOR.current_selection.relay_store);
                    window.JPSTORELOCATOR.current_selection.relay_email = relayEmail;
                    sessionStorage.setItem('relay_email', window.JPSTORELOCATOR.current_selection.relay_email);
                    window.JPSTORELOCATOR.current_selection.order_value = order_value;
                    sessionStorage.setItem('order_value', window.JPSTORELOCATOR.current_selection.order_value);
                    window.JPSTORELOCATOR.current_selection.order_condition = order_condition;
                    sessionStorage.setItem('order_condition', window.JPSTORELOCATOR.current_selection.order_condition);
                    if (cartData?.token) {
                        window.location = link;
                    }
                }
            });
            return;
        }

        let cartData = window.JPSTORELOCATOR.methods.clearCart ? (
            await window.JPSTORELOCATOR.methods.clearCart()
        ) : '';

        // localStorage.setItem('title', title);
        // localStorage.setItem('location', location);
        window.JPSTORELOCATOR.current_selection = window.JPSTORELOCATOR.current_selection || {};

        window.JPSTORELOCATOR.current_selection.zapiet_location_id = zapiet_location_id;
        sessionStorage.setItem('zapiet_location_id', zapiet_location_id);
        let parsedLocation = parseAddress.parseLocation(location);
        if (parsedLocation || window.JPSTORELOCATOR.source) {
            window.JPSTORELOCATOR.current_selection.zip = (window.JPSTORELOCATOR.current_selection.delivery_type_handle === "market" || window.JPSTORELOCATOR.current_selection.delivery_type_handle === "local") ? (
                window.JPSTORELOCATOR.source.zip || parsedLocation?.zip || ''
            ) : (parsedLocation?.zip || window.JPSTORELOCATOR.source?.zip || '');
        }
        sessionStorage.setItem('location_zip', window.JPSTORELOCATOR.current_selection.zip);
        window.JPSTORELOCATOR.current_selection.location_link = link;
        sessionStorage.setItem('location_link', link);
        window.JPSTORELOCATOR.current_selection.location_title = title;
        sessionStorage.setItem('location_title', window.JPSTORELOCATOR.current_selection.location_title);
        window.JPSTORELOCATOR.current_selection.location = location;
        sessionStorage.setItem('location_address', window.JPSTORELOCATOR.current_selection.location);
        window.JPSTORELOCATOR.current_selection.relay_store = relayStore;
        sessionStorage.setItem('relay_store', window.JPSTORELOCATOR.current_selection.relay_store);
        window.JPSTORELOCATOR.current_selection.relay_email = relayEmail;
        sessionStorage.setItem('relay_email', window.JPSTORELOCATOR.current_selection.relay_email);
        window.JPSTORELOCATOR.current_selection.order_value = order_value;
        sessionStorage.setItem('order_value', window.JPSTORELOCATOR.current_selection.order_value);
        window.JPSTORELOCATOR.current_selection.order_condition = order_condition;
        sessionStorage.setItem('order_condition', window.JPSTORELOCATOR.current_selection.order_condition);
        if (cartData?.token) {
            document.cookie = `originURL=${window.location.hostname}; domain=.juicepress.com; path=/; Secure; SameSite=None`;
            window.location = link;
        }


    }

    if(_storeSearchBtn){
        _storeSearchBtn.addEventListener('click', () => {
            clearError();
            event.preventDefault();
            event.stopPropagation();

            // get delivery type
            let deliveryType = window.JPSTORELOCATOR.current_selection.delivery_type || '';
            // let deliveryPopupElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_delivery_popup_id);
            // let pickupPopupElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_pickup_popup_id);
            let nofoundTextElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_text_id);
            let nofoundShopElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_not_found_shop_id);
            let locationWrapperElem = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_wrapper_id);
            let subDeliveryHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_header_id);
            let subDeliveryInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_delivery_inner_id);
            let subPickupHeader = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_header_id);
            let subPickupInner = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_sub_pickup_inner_id);

            
            nofoundTextElem ? (
                nofoundTextElem.classList.add('hide')
            ) : null;
            nofoundShopElem ? (
                nofoundShopElem.classList.add('hide')
            ) : null;   
            locationWrapperElem ? (
                locationWrapperElem.classList.add('hide')
            ) : null;   
            subDeliveryHeader ? (
                subDeliveryHeader.classList.add('hide')
            ) : null;
            subDeliveryInner ? (
                subDeliveryInner.classList.add('hide')
            ) : null;
            subPickupHeader ? (
                subPickupHeader.classList.add('hide')
            ) : null;
            subPickupInner ? (
                subPickupInner.classList.add('hide')
            ) : null;
            
            // check for current delivery method
            if(deliveryType === ''){
                nofoundTextElem ? (
                    nofoundTextElem.classList.remove('hide')
                ) : null;
                nofoundShopElem ? (
                    nofoundShopElem.classList.remove('hide')
                ) : null;   
                locationWrapperElem ? (
                    locationWrapperElem.classList.remove('hide')
                ) : null;   
                _clearLocationList();
                return false;
            }
            
            
            if(deliveryType === 'DELIVERY'){
                document.getElementById('delivery1').checked = false;
                document.getElementById('delivery2').checked = false;
                document.getElementById('delivery3').checked = false;
                document.getElementById('jp-nationwide-shipping-box').classList.remove('col-md-offset-3');
                document.getElementById('jp-market-delivery-box').classList.remove('col-md-offset-3');

                if(isNationWideShippingEnable() === 2){
                    document.getElementById('jp-market-delivery-box').classList.add('col-md-offset-3');
                    document.getElementById('jp-market-delivery-box').classList.remove('hidePopupSection');
                    document.getElementById('jp-local-delivery-box').classList.add('hidePopupSection');
                    // document.getElementById('jp-nationwide-shipping-box').classList.remove('hidePopupSection');
                    document.getElementById('jp-nationwide-shipping-box').classList.add('hidePopupSection');
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('delivery2'),'change');
                }else if(isNationWideShippingEnable() === 1){
                    document.getElementById('jp-local-delivery-box').classList.add('hidePopupSection');
                    document.getElementById('jp-market-delivery-box').classList.add('hidePopupSection');
                    document.getElementById('jp-nationwide-shipping-box').classList.add('col-md-offset-3');
                    document.getElementById('jp-nationwide-shipping-box').classList.remove('hidePopupSection');
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('delivery3'),'change');
                }else if(isNationWideShippingEnable() === 0){
                    // document.getElementById('jp-market-delivery-box').classList.remove('hidePopupSection');
                    // document.getElementById('jp-local-delivery-box').classList.remove('hidePopupSection');
                    // document.getElementById('jp-nationwide-shipping-box').classList.add('hidePopupSection');
                    // $(deliveryPopupElem).modal('show');
                    // $(deliveryPopupElem).on('shown.bs.modal', function(e){
                    //     if($(window).width() > 991){
                    //         equalheight('.popsubtitle');
                    //         equalheight('.order-content');
                    //     }
                    // });

                    document.getElementById('jp-store-locator__location-wrapper').classList.remove('hide');
                    document.getElementById('jp-store-locator__sub-delivery-header').classList.remove('hide');
                    document.getElementById('jp-store-locator__sub-delivery-inner').classList.remove('hide');
                    loadlocation('', 'GRAB-AND-GO DELIVERY', 4);
                }
            }else if(deliveryType === 'PICKUP'){
                document.getElementById('pickup1').checked = false;
                document.getElementById('pickup2').checked = false;
                document.getElementById('pickup3').checked = false;
                document.getElementById('jp-nationwide-shipping-pickup-box').classList.remove('col-md-offset-3');
                document.getElementById('jp-market-pickup-box').classList.remove('col-md-offset-3');
                
                if(isNationWideShippingEnable() === 2){
                    document.getElementById('jp-market-pickup-box').classList.add('col-md-offset-3');
                    document.getElementById('jp-market-pickup-box').classList.remove('hidePopupSection');
                    document.getElementById('jp-standard-pickup-box').classList.add('hidePopupSection');
                    // document.getElementById('jp-nationwide-shipping-box').classList.remove('hidePopupSection');
                    document.getElementById('jp-nationwide-shipping-pickup-box').classList.add('hidePopupSection');
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('pickup2'),'change');
                }else if(isNationWideShippingEnable() === 1){
                    document.getElementById('jp-standard-pickup-box').classList.add('hidePopupSection');
                    document.getElementById('jp-market-pickup-box').classList.add('hidePopupSection');
                    document.getElementById('jp-nationwide-shipping-pickup-box').classList.add('col-md-offset-3');
                    document.getElementById('jp-nationwide-shipping-pickup-box').classList.remove('hidePopupSection');
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('pickup3'),'change');
                }else if(isNationWideShippingEnable() === 0){
                    // document.getElementById('jp-market-pickup-box').classList.remove('hidePopupSection');
                    // document.getElementById('jp-standard-pickup-box').classList.remove('hidePopupSection');
                    // document.getElementById('jp-nationwide-shipping-pickup-box').classList.add('hidePopupSection');
                    // $(pickupPopupElem).modal('show');
                    // $(pickupPopupElem).on('shown.bs.modal', function(e){
                    //     if($(window).width() > 991){
                    //         equalheight('.popsubtitle');
                    //         equalheight('.order-content');
                    //     }
                    // });

                    document.getElementById('jp-store-locator__location-wrapper').classList.remove('hide');
                    document.getElementById('jp-store-locator__sub-pickup-header').classList.remove('hide');
                    document.getElementById('jp-store-locator__sub-pickup-inner').classList.remove('hide');
                    loadlocation('', 'STANDARD PICKUP', 7);
                }
            } else{
                sessionStorage.setItem('delivery_type', deliveryType);
                _searchForAvailableStoreInArea();
            }

        });

    }

    if(_searchInput){
        let _searchSubmitBtn = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_store_search_id);
        let _searchInputPlaceHolderText = document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_search_input_text_id);
        _searchInput.addEventListener('keyup', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            if(_searchSubmitBtn){
                _searchSubmitBtn.disabled = true;
            }
            
            if(!event.target.value && event.target.value !== ''){
                if(_searchSubmitBtn){
                    _searchSubmitBtn.disabled = false;
                }
                if(_searchInputPlaceHolderText){
                    _searchInputPlaceHolderText.classList.add('hide');
                }
                setTimeout(() => {
                    //_searchForAvailableStoreInArea();    
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('jp-store-locator__store-search-btn'),'click');
                }, 300);
                
                
            }else if(event.target.value === ''){
                if(_searchInputPlaceHolderText){
                    _searchInputPlaceHolderText.classList.remove('hide');
                }
                
                if(window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'standard-pickup' || window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'market-pickup'){
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box1'),'click');
                    setTimeout(() => {
                        _searchForAvailableStoreInArea();    
                    }, 300);
                }else{
                  if (!window.location.href.includes('/location')) {
                        window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box2'), 'click');
                    }
                }
            }
            
        });
        _searchInput.addEventListener('keydown', (event) => {
            if(event.code === "Home" && event.shiftKey === true ||
            event.code === "KeyA" && event.ctrlKey === true ||
            event.code === "ArrowLeft" && event.shiftKey === true
            ){
                _searchInput.value = '';
                if(window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'standard-pickup' || window.JPSTORELOCATOR.current_selection.delivery_type_handle === 'market-pickup'){
                    window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box1'),'click');
                }else{
                    if (!window.location.href.includes('/location')) {
                        window.JPSTORELOCATOR.methods.triggerEvent(document.getElementById('box2'), 'click');
                    }
                }
                document.getElementById(window.JPSTORELOCATOR.selectors.jp_store_locator_location_clear_id).style.visibility = "hidden";
            }
        });
    }
    
    initPlacesAutocomplete();
    
    return {
        searchForAvailableStoreInArea:_searchForAvailableStoreInArea,
        clearErrorMessage:clearError
    };
})(window.JPSTORELOCATOR);

